<div class="container">
	<ng-container *ngTemplateOutlet="mobileTopBar"></ng-container>
	<div class="container__routes">
		<!--    <a class="container__route" [routerLink]="mainRoutes.Dashboard" routerLinkActive="container__route&#45;&#45;active">{{ 'SIDEBAR.HOME' | translate }}</a>-->
		<!--      TODO: Implement when new dashboard is ready (only Dev now) -->
		<a class="container__route" [routerLink]="mainRoutes.Dashboard" routerLinkActive="container__route--active">{{
			'SIDEBAR.HOME' | translate
		}}</a>
		<a class="container__route" [routerLink]="mainRoutes.Reports" routerLinkActive="container__route--active">{{
			'SIDEBAR.TIME_EXPENSES' | translate
		}}</a>
		<a
			*visibleForRoles="[
				userRole.Partner,
				userRole.Lawyer,
				userRole.Intern,
				userRole.Finance,
				userRole.Secretary,
				userRole.Other
			]"
			class="container__route"
			[routerLink]="mainRoutes.Clients"
			routerLinkActive="container__route--active"
			>{{ 'SIDEBAR.CLIENT_MATTERS' | translate }}</a
		>
		<a
			*visibleForRoles="[userRole.Partner, userRole.Finance, userRole.Secretary]"
			class="container__route"
			[routerLink]="mainRoutes.Management"
			routerLinkActive="container__route--active"
			>{{ 'SIDEBAR.FINANCE_MANAGEMENT' | translate }}</a
		>
		<a class="container__route" [routerLink]="mainRoutes.Organization" routerLinkActive="container__route--active">{{
			'SIDEBAR.ORGANIZATION' | translate
		}}</a>
		@if (documentsManagement()) {
			<a class="container__route" [routerLink]="mainRoutes.DocumentsManagement" routerLinkActive="container__route--active">{{
				'SIDEBAR.DOCUMENTS_MANAGEMENT' | translate
			}}</a>
		}
		@if (newMatter()) {
			<a class="container__route" [routerLink]="mainRoutes.NewMatter" routerLinkActive="container__route--active">{{
				'SIDEBAR.NEW_MATTER' | translate
			}}</a>
		}
		@if (tasks()) {
			<a class="container__route" [routerLink]="mainRoutes.Tasks" routerLinkActive="container__route--active">{{
				'SIDEBAR.TASKS' | translate
			}}</a>
		}
	</div>
	<div class="container__profile-and-settings-wrapper">
		@if (firmRegion === firmRegionEnum.Israel) {
			<div class="container__language-button" (click)="toggleLanguage(alternativeLang)">
				<span>
					{{ alternativeLang | uppercase }}
				</span>
			</div>
		}
		@if (hasLawyalTime || this.isFinanceOrSecretary || displayWhatsAppSignup) {
			<div class="container__icon">
				<mat-icon
					[matMenuTriggerFor]="menu1"
					#menuTrigger1="matMenuTrigger"
					[class.menu-open]="menuTrigger1.menuOpen"
					svgIcon="gear"
				></mat-icon>
				<mat-menu backdropClass="container__dropdown-menu" #menu1="matMenu">
					<div
						*visibleForRoles="[userRole.Finance, userRole.Secretary]"
						(click)="emitSelectedAction(navBarOption.CreateUniformFile)"
						class="container__dropdown-option"
					>
						<span>
							{{ 'SETTINGS.CREATE_FILE' | translate }}
						</span>
					</div>
					<div
						*visibleForRoles="[]"
						(click)="emitSelectedAction(navBarOption.NotificationsPanel)"
						class="container__dropdown-option"
					>
						<span>
							{{ 'SETTINGS.NOTIFICATIONS_PANEL' | translate }}
						</span>
					</div>
					<div
						*visibleForRoles="[userRole.Finance, userRole.Secretary]"
						(click)="emitSelectedAction(navBarOption.Import)"
						class="container__dropdown-option"
					>
						<span>
							{{ 'SETTINGS.IMPORT' | translate }}
						</span>
					</div>
					<div
						*visibleForRoles="[]"
						(click)="emitSelectedAction(navBarOption.BookkeepingPeriod)"
						class="container__dropdown-option"
					>
						<span>
							{{ 'SETTINGS.BOOKKEEPING_PERIOD' | translate }}
						</span>
					</div>
					<div
						*visibleForRoles="[userRole.Finance]"
						(click)="emitSelectedAction(navBarOption.ReportingPeriod)"
						class="container__dropdown-option"
					>
						<span>
							{{ 'SETTINGS.REPORTING_PERIOD' | translate }}
						</span>
					</div>
					<div
						*visibleForRoles="[]"
						(click)="emitSelectedAction(navBarOption.IsraelInvoicing)"
						class="container__dropdown-option"
					>
						<span>
							{{ 'SETTINGS.ISRAEL_INVOICE' | translate }}
						</span>
					</div>
					@if (displaySetVATOption) {
						<div (click)="emitSelectedAction(navBarOption.SetVatValue)" class="container__dropdown-option">
							<span>
								{{ 'SETTINGS.SET_VAT_VALUE' | translate }}
							</span>
						</div>
					}
					@if (displayWhatsAppSignup) {
						<div (click)="emitSelectedAction(navBarOption.WhatsAppSignup)" class="container__dropdown-option">
							<span>
								{{ 'SETTINGS.WHATSAPP_SIGNUP' | translate }}
							</span>
						</div>
					}
					<div
						*visibleForRoles="[
							userRole.Intern,
							userRole.Secretary,
							userRole.Lawyer,
							userRole.Partner,
							userRole.Finance,
							userRole.Other
						]"
						[className]="hasLawyalTime ? 'container__dropdown-option' : 'container__dropdown-option--hidden'"
						(click)="emitSelectedAction(navBarOption.PersonalHelper)"
					>
						<span>
							{{ 'SETTINGS.PERSONAL_HELPER' | translate }}
						</span>
					</div>
					<!--        <div--><!--TODO: Add when feature is ready-->
					<!--          *visibleForRoles="[userRole.Intern, userRole.Secretary, userRole.Lawyer, userRole.Partner, userRole.Finance, userRole.Other]"-->
					<!--          (click)="emitSelectedAction(navBarOption.DatesCalculator)"-->
					<!--          class="container__dropdown-option">-->
					<!--          <span>-->
					<!--						{{ 'SETTINGS.DATES_CALCULATOR' | translate }}-->
					<!--					</span>-->
					<!--        </div>-->
				</mat-menu>
				<!--TODO: maybe create a component-->
			</div>
		}
		<div class="container__icon">
			<mat-icon
				[matMenuTriggerFor]="menu2"
				#menuTrigger2="matMenuTrigger"
				[class.menu-open]="menuTrigger2.menuOpen"
				svgIcon="profile"
			></mat-icon>
			<!--TODO: Change menu2 to other name.-->
			<mat-menu backdropClass="container__dropdown-menu" #menu2="matMenu"
				><!--TODO: maybe create a component-->
				<div (click)="emitSelectedAction(navBarOption.Logout)" class="container__dropdown-option">
					<span>
						{{ 'HEADER.USER_MENU.LOG_OUT' | translate }}
					</span>
				</div>
			</mat-menu>
		</div>
	</div>
</div>

<ng-template #mobileTopBar>
	<div class="container__mobile-top-bar-icon container__mobile-top-bar-icon--clickable">
		<mat-icon
			[matMenuTriggerFor]="menu3"
			#menuTrigger3="matMenuTrigger"
			[class.menu-open]="menuTrigger3.menuOpen"
			svgIcon="hamburger"
		></mat-icon>
		<mat-menu backdropClass="container__dropdown-menu" #menu3="matMenu"
			><!--TODO: maybe create a component-->
			<div class="container__mobile-dropdown-option">
				<a class="container__mobile-route" routerLink="/mobile-dashboard" routerLinkActive="container__mobile-route--active">
					<span class="container__mobile-route-text">
						{{ 'SIDEBAR.HOME' | translate }}
					</span>
				</a>
				<!--TODO: use the enum for the route name-->
			</div>
			<div class="container__mobile-dropdown-option">
				<a class="container__mobile-route" routerLink="/reports" routerLinkActive="container__mobile-route--active">
					<span class="container__mobile-route-text">
						{{ 'SIDEBAR.TIME_EXPENSES' | translate }}
					</span>
				</a>
				<!--TODO: use the enum for the route name-->
			</div>
			<div (click)="emitSelectedAction(navBarOption.Logout)" class="container__mobile-dropdown-option">
				<span class="container__mobile-route-text">
					{{ 'HEADER.USER_MENU.LOG_OUT' | translate }}
				</span>
			</div>
		</mat-menu>
	</div>
	<div class="container__mobile-top-bar-icon">
		<mat-icon svgIcon="logo"></mat-icon>
	</div>
	<div class="container__notification-and-language-wrapper container__mobile-top-bar-icon">
		<div class="container__language-button container__language-button--mobile" (click)="toggleLanguage(alternativeLang)">
			<span>
				{{ alternativeLang | uppercase }}
			</span>
		</div>
		<div class="container__mobile-top-bar-icon container__mobile-top-bar-icon--clickable">
			<!--    TODO: create a component that will be used in this component and in the side-bar.component-->
			<mat-icon
				svgIcon="new_bell"
				[matMenuTriggerFor]="menu4"
				#menuTrigger="matMenuTrigger"
				[class.menu-open]="menuTrigger.menuOpen"
				[matBadge]="notificationsCounter?.toString()"
				[matBadgeHidden]="!notificationsCounter"
				matBadgeColor="warn"
				matBadgeSize="small"
				matBadgePosition="below before"
				aria-hidden="false"
			></mat-icon>
			<mat-menu #menu4="matMenu" backdropClass="notification-drop-down-backdrop" classList="notification-drop-down-container">
				<lawyal-front-end-notification-drop-down
					[notifications]="activeNotifications"
					[isMarkAllAsReadDisabled]="!hasNewNotifications"
					(closeModal)="menuTrigger.closeMenu()"
					(decrementCounter)="decrementCounter()"
					(openModal)="openModalFromSnackBar($event)"
					(runMigration)="onRunMigration($event)"
					(markedAllAsRead)="calcNotifications()"
				></lawyal-front-end-notification-drop-down>
			</mat-menu>
		</div>
	</div>
</ng-template>
